import React from 'react';
import AuthService from './authService.js';

class ProjectService extends React.Component {
  static GetProjectList(
    clientFeeId,
    clientIdFilter,
    projectIdFilter,
    opportunityIdFilter,
    surveyIdFilter,
    tpProjectIdFilter,
    tpSurveyIdFilter
  ) {
    const searchItem = {
      ClientId: clientIdFilter,
      ProjectId: projectIdFilter,
      OpportunityId: opportunityIdFilter,
      SurveyId: surveyIdFilter,
      TpProjectId: tpProjectIdFilter,
      TpSurveyId: tpSurveyIdFilter,
    };

    let url = '/api/ClientFee';

    if (clientFeeId != null && clientFeeId !== -1) {
      url += `/${clientFeeId}?clearCache=true`;
    } else {
      url += `?searchItem=${JSON.stringify(searchItem)}&clearCache=true`;
    }

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static GetProjectNameById(projectId) {
    const authService = AuthService.getInstance();
    const url = `/api/ClientFee/GetClientFeeNameById/${projectId}/?clearCache=false`;
    return authService.CallBackendFunction(url);
  }

  static getProjectNames(id, tip) {
    const authService = AuthService.getInstance();
    const url = `/api/ClientFee/GetProjectNames?id=${id}&tip=${tip}&clearCache=true`;
    return authService.CallBackendFunction(url);
  }
}

export default ProjectService;
